import styled from 'styled-components';

export const SLabel = styled.span`
    margin-top: 1rem;
`;
